"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enhanceLinks = exports.hasProtocol = void 0;
var email_validator_1 = require("email-validator");
var is_valid_domain_1 = __importDefault(require("is-valid-domain"));
var hasProtocol = function (link) {
    var lowerCaseLink = link.toLowerCase();
    return Boolean(lowerCaseLink.match(/^[a-z][a-z0-9+-.]*:/i));
};
exports.hasProtocol = hasProtocol;
/**
 * Scans the document for links that don't start
 * with a protocol and adds one automatically.
 */
var addHttpsToRelativeLinks = function ($) {
    $('a').each(function (_, link) {
        var href = link.attribs.href;
        if (href && !exports.hasProtocol(href)) {
            if (is_valid_domain_1.default(href.split('/')[0])) {
                // Valid domains are prepended with https://
                link.attribs.href = "https://" + href;
            }
            else if (email_validator_1.validate(href)) {
                // Valid email addresses get an extra mailto:
                link.attribs.href = "mailto:" + href;
            }
        }
    });
};
var addTitlesToLinks = function ($) {
    $('a').each(function (_, link) {
        if (link.attribs.title) {
            link.attribs.title += " (" + link.attribs.href + ")";
        }
        else {
            link.attribs.title = link.attribs.href;
        }
    });
};
var enhanceLinks = function ($) {
    addHttpsToRelativeLinks($);
    addTitlesToLinks($);
};
exports.enhanceLinks = enhanceLinks;
